import { IFeatureFlags } from 'types';
import { beta } from './beta';

// inherits beta configuration
export const alpha: IFeatureFlags = Object.assign({}, beta, {});

Object.freeze(alpha);
